import Settings from '../settings'
import { CoachHttpClientFactory } from '@mojility/coach-core'
import { json } from 'aurelia-fetch-client'

export default class EditorGateway {
  constructor(coachHttpClientFactory) {
    this.http = coachHttpClientFactory;
  }

  loadDetailedQuestionnaire(secretKey, questionnaireID, onSuccess) {
    return this.http.createAuthenticatedClient(secretKey).fetch(Settings.serviceUrl + '/api/v1/questionnaire/coach/' + questionnaireID, {
      method: 'get'
    }).then(response => response.json().then(data => onSuccess(data)))
  }

  updateQuestionnaireTitle(secretKey, questionnaireId, newTitle, onSuccess, onFailure) {
    return this.http.createAuthenticatedClient(secretKey).fetch(Settings.serviceUrl + '/api/v1/questionnaire/' + questionnaireId + '/title', {
      method: 'put',
      body: json(newTitle)
    }).then(response => {
      switch (response.status) {
        case 200:
          return response.json().then(data => onSuccess(data));
        default:
          return response.json().then(data => onFailure(data));
      }
    });
  }

  updateQuestionnaireDescription(secretKey, questionnaireId, newDescription, onSuccess, onFailure) {
    return this.http.createAuthenticatedClient(secretKey).fetch(Settings.serviceUrl + '/api/v1/questionnaire/' + questionnaireId + '/description', {
      method: 'put',
      body: json(newDescription)
    }).then(response => {
      switch (response.status) {
        case 200:
          return response.json().then(data => onSuccess(data));
        default:
          return response.json().then(data => onFailure(data));
      }
    });
  }

  updateQuestionInQuestionnaire(secretKey, data, onSuccess, onFailure) {
    return this.http.createAuthenticatedClient(secretKey).fetch(Settings.serviceUrl + '/api/v1/questionnaire/' + data.questionnaire_id + '/question', {
      method: 'put',
      body: json(data)
    }).then(response => {
      switch (response.status) {
        case 200:
          return response.json().then(data => onSuccess(data));
        default:
          return response.json().then(data => onFailure(data));
      }
    });
  }

  removeQuestionFromQuestionnaire(secretKey, questionnaireId, questionPosition, onSuccess, onFailure) {
    return this.http.createAuthenticatedClient(secretKey).fetch(Settings.serviceUrl + '/api/v1/questionnaire/' + questionnaireId + '/question/' + questionPosition, {
      method: 'delete'
    }).then(response => {
      switch (response.status) {
        case 200:
          return response.json().then(data => onSuccess(data));
        default:
          return response.json().then(data => onFailure(data));
      }
    });
  }

  createNewQuestion(secretKey, questionnaireId, questionData, onSuccess, onFailure) {
    return this.http.createAuthenticatedClient(secretKey).fetch(Settings.serviceUrl + '/api/v1/questionnaire/' + questionnaireId + '/question', {
      method: 'post',
      body: json(questionData)
    }).then(response => {
      switch (response.status) {
        case 200:
          return response.json().then(data => onSuccess(data));
        default:
          return response.json().then(data => onFailure(data));
      }
    }).catch(() => {
      onFailure();
    });
  }

  repositionQuestion(secretKey, questionnaireId, data, onSuccess, onFailure) {
    return this.http.createAuthenticatedClient(secretKey).fetch(Settings.serviceUrl + '/api/v1/questionnaire/' + questionnaireId + '/reposition', {
      method: 'put',
      body: json(data)
    }).then(response => {
      switch (response.status) {
        case 200:
          return response.json().then(data => onSuccess(data));
        default:
          return response.json().then(data => onFailure(data));
      }
    });
  }

  addQuestionToSection(secretKey, questionnaireId, questionPosition, sectionTitle, onSuccess, onFailure) {
    return this.http.createAuthenticatedClient(secretKey).fetch(Settings.serviceUrl + '/api/v1/questionnaire/' + questionnaireId + '/' + questionPosition + '/sections', {
      method: 'put',
      body: json({section_title: sectionTitle})
    }).then(response => {
      switch (response.status) {
        case 200:
          return response.json().then(data => onSuccess(data));
        default:
          return response.json().then(data => onFailure(data));
      }
    });
  }

  reorderSections(secretKey, questionnaireId, newSectionOrder, onSuccess, onFailure) {
    return this.http.createAuthenticatedClient(secretKey).fetch(Settings.serviceUrl + '/api/v1/questionnaire/' + questionnaireId + '/sections', {
      method: 'put',
      body: json({ordered_sections: newSectionOrder})
    }).then(response => {
      switch (response.status) {
        case 200:
          return response.json().then(data => onSuccess(data));
        default:
          return response.json().then(data => onFailure(data));
      }
    });
  }

  updateSectionTitle(secretKey, questionnaireId, originalTitle, newTitle, onSuccess, onFailure) {
    return this.http.createAuthenticatedClient(secretKey).fetch(Settings.serviceUrl + '/api/v1/questionnaire/' + questionnaireId + '/sections/rename', {
      method: 'put',
      body: json({
        new_title: newTitle,
        old_title: originalTitle
      })
    }).then(response => {
      switch (response.status) {
        case 200:
          return response.json().then(data => onSuccess(data));
        default:
          return response.json().then(data => onFailure(data));
      }
    });
  }

  updateSectionDescription(secretKey, questionnaireId, sectionTitle, newDescription, onSuccess, onFailure) {
    return this.http.createAuthenticatedClient(secretKey).fetch(Settings.serviceUrl + '/api/v1/questionnaire/' + questionnaireId + '/sections/describe', {
      method: 'put',
      body: json({
        description: newDescription,
        title: sectionTitle
      })
    }).then(response => {
      switch (response.status) {
        case 200:
          return response.json().then(data => onSuccess(data));
        default:
          return response.json().then(data => onFailure(data));
      }
    });
  }

  tagSection(secretKey, questionnaireId, sectionTitle, newTagName, onSuccess, onFailure) {
    return this.http.createAuthenticatedClient(secretKey).fetch(Settings.serviceUrl + '/api/v1/questionnaire/' + questionnaireId + '/sections/tag', {
      method: 'post',
      body: json({
        tag_name: newTagName,
        section_title: sectionTitle
      })
    }).then(response => {
      switch (response.status) {
        case 200:
          return response.json().then(data => onSuccess(data.tag_name));
        default:
          return response.json().then(data => onFailure(data));
      }
    });
  }

  untagSection(secretKey, questionnaireId, sectionTitle, tagName, onSuccess, onFailure) {
    return this.http.createAuthenticatedClient(secretKey).fetch(Settings.serviceUrl + '/api/v1/questionnaire/' + questionnaireId + '/sections/' + sectionTitle + '/tag/' + tagName, {
      method: 'delete'
    }).then(response => {
      switch (response.status) {
        case 200:
          return response.json().then(data => onSuccess(data.tag_name));
        default:
          return response.json().then(data => onFailure(data));
      }
    });
  }

  createEmptySection(secretKey, questionnaireId, sectionTitle, onSuccess, onFailure) {
    return this.http.createAuthenticatedClient(secretKey).fetch(Settings.serviceUrl + '/api/v1/questionnaire/' + questionnaireId + '/sections', {
      method: 'post',
      body: json({
        title: sectionTitle,
        questionnaire_id: questionnaireId
      })
    }).then(response => {
      switch (response.status) {
        case 200:
          return response.json().then(data => onSuccess(data.title));
        default:
          return response.json().then(data => onFailure(data));
      }
    });
  }

  deleteSection(secretKey, questionnaireId, sectionTitle, onSuccess, onFailure) {
    return this.http.createAuthenticatedClient(secretKey).fetch(Settings.serviceUrl + '/api/v1/questionnaire/' + questionnaireId + '/sections/delete', {
      method: 'put',
      body: json({
        title: sectionTitle
      })
    }).then(response => {
      switch (response.status) {
        case 200:
          return response.json().then(data => onSuccess(data));
        default:
          return response.json().then(data => onFailure(data));
      }
    });
  }
}